import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './tasteProfileIcon.css'

import bigRed from 'images/smaakprofielen/bigRed.png'
import bigWhite from 'images/smaakprofielen/bigWhite.png'
import classicRed from 'images/smaakprofielen/classicRed.png'
import classicWhite from 'images/smaakprofielen/classicWhite.png'
import easyRider from 'images/smaakprofielen/easyRider.png'
import freshHammer from 'images/smaakprofielen/freshHammer.png'
import freshPrince from 'images/smaakprofielen/freshPrince.png'
import freshRed from 'images/smaakprofielen/freshRed.png'
import fruitLover from 'images/smaakprofielen/fruitLover.png'
import fruitSmoothie from 'images/smaakprofielen/fruitSmoothie.png'
import royalRed from 'images/smaakprofielen/royalRed.png'
import sugarHoney from 'images/smaakprofielen/sugarHoney.png'

export const icons = {
  bigRed,
  bigWhite,
  classicRed,
  classicWhite,
  easyRider,
  freshHammer,
  freshPrince,
  freshRed,
  fruitLover,
  fruitSmoothie,
  royalRed,
  sugarHoney
}
export const iconNames = Object.keys(icons)
class TasteProfileIcon extends PureComponent {
  render () {
    const { profile, width, className } = this.props
    const props = {
      style: {
      },
      className: classnames(
        styles[`${profile}`],
        className
      )
    }
    if (width && (width > 0)) {
      props.style.width = `${width}px`
    }

    return (
      <span {...props} />
    )
  }
}

TasteProfileIcon.propTypes = {
  profile: PropTypes.oneOf(iconNames).isRequired,
  className: PropTypes.string,
  width: PropTypes.number
}

TasteProfileIcon.defaultProps = {
  width: 150,
  className: null,
  profile: iconNames[0]
}

export default TasteProfileIcon
